import { render, staticRenderFns } from "./commentType.vue?vue&type=template&id=b857c45c"
import script from "./commentType.vue?vue&type=script&lang=js"
export * from "./commentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports